import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { NavBarComponent } from './nav-bar';

@NgModule({
  declarations: [
    NavBarComponent
  ],
  imports: [
    IonicModule.forRoot(NavBarComponent)
  ],
  bootstrap: [
    IonicApp
  ],
  entryComponents: [
    NavBarComponent
  ],
  exports: [NavBarComponent],
  providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}]
})
export class NavBarModule { }


// WEBPACK FOOTER //
// ./src/components/nav-bar/nav-bar.module.ts